import {
    createUnknownComponentVNode as _$cc,
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
} from 'intact';
import {linkEvent} from 'intact';
import {getRestProps, addStyle} from '../utils';
import {makeStepStyles} from './styles';
import {context as StepsContext} from './context';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {children, title, index, className, style} = this.get();
    
    return _$cc(StepsContext.Consumer, {
        'children': ({value, status, width, onChange}) => {
            const selected = value === index;
            const error = selected && status === 'error';
            const classNameObj = {
                'k-step': true,
                'k-active': selected,
                'k-done': value > index,
                'k-error': error,
                [className]: className,
                [makeStepStyles()]: true,
            };
        
            return _$cv('div', {
                ...getRestProps(this),
                'className': _$cn(classNameObj),
                'style': addStyle(style, {width}),
                'ev-click': linkEvent(index, onChange)
            }, [
                _$ce(2, 'div', null, 1, 'k-step-tail'),
                _$ce(2, 'div', [
                    _$ce(2, 'div', (
                        _$ce(2, 'div', (
                            (error) ?
                                _$ce(2, 'i', null, 1, 'k-step-icon ion-ios-close-empty') :
                                _$ce(2, 'span', index + 1, 0)
                        ), 2, 'k-step-inner')
                    ), 2, 'k-step-head'),
                    _$ce(2, 'div', [
                        _$ce(2, 'div', title, 0, 'k-step-title'),
                        _$ce(2, 'div', children, 0, 'k-step-content')
                    ], 4, 'k-step-main')
                ], 4, 'k-step-wrapper')
            ])
        }
    });
};